import { createContext } from "react";
import { NavTreeClient, DashboardClient } from "@cayo/shared/api/schema";
import { IScheme } from "@cayo/shared/api/types/schema";
import UserProfileClient from "@cayo/shared/api/UserProfileClient";
import { IHealthCheckClient } from "@cayo/shared/components/AppState/api/healthCheck";
import { UIInteraction } from "@cayo/shared/hooks/useUIInteraction";
import { IActionBuilder } from "@cayo/shared/scheme/actions";
import { INotificationService } from "@cayo/shared/services/notifications";
import { ViewStorageFactory } from "@cayo/shared/settings/viewStorage";

export interface IServices {
  actionBuilder: IActionBuilder;
  uiInteraction: UIInteraction;

  navTreeClient: NavTreeClient;
  userProfileClient: UserProfileClient<IScheme>;
  dashboardClient: DashboardClient;

  viewStorageFactory: ViewStorageFactory;

  healthCheck: IHealthCheckClient;
  notificationService: INotificationService;
}

export default createContext<IServices>({} as IServices);
